import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    OnDestroy,
    OnInit,
    Renderer2,
    ViewChild
} from '@angular/core';
// import { MenuItem } from 'primeng/api'
import {MenuItem} from './menu.model';
import {BASELINK, command} from './menu';
import {NavigationEnd, Router} from '@angular/router';
import {MenuService} from "../../lib/services/menu/menu.service";
import {UserUtilsService} from "../../lib/services/user/user-utils.service";
import * as pubsub from "pubsub-js"
import {firstValueFrom} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {ContractService, SystemAuthenticationService, UtilsService} from '@monex-sistemas/nueva-banca-digital-library';
import {RedirectService} from "../../lib/services/redirect/redirect.service";
import {MonexUltra2Service} from '../../lib/services/monex-ultra-2/monex-ultra2.service';
import {ValidationTermsAndCondition, ValidationUserResponse} from '../../lib/models/monex-ultra.model';
import {UserInfo} from '../../lib/models/user-info.model';
import {ValidateTokenService} from "../../lib/services/validate-token/validate-token.service";
import {JwtService} from "../../lib/services/jwt/jwt.service";
import {ToastService} from "../../lib/services/toast/toast.service";
import {filter} from "rxjs/operators";

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, AfterViewInit, OnDestroy {

    @ViewChild('sidebarToggler') sidebarToggler!: ElementRef;

    menuItems: MenuItem[] = [];
    items: any
    contractSelected: any
    userInfoSessionStorage: UserInfo
    userAlreadyAcceptTC: ValidationTermsAndCondition;
    translation: any;
    otpCode: string = "";
    tokenStatus: boolean = false
    isClicked: boolean = true
    isMenuOpened: boolean = true
    @ViewChild('sidebarMenu') sidebarMenu!: ElementRef;
    translations: any;
    private enterTimeout: any = null;
    private isMouseInsideMenu: boolean = false;

    //Se ocupa cuando en el menu de menu.ts no existe el subitem.
    menuSpecialCases = {
        "/nueva-banca-digital/destinatarios/autorizacion/bulk": {
            replaceTo: "/nueva-banca-digital/destinatarios/autorizacion/single"
        },
        "/nueva-banca-digital/pagos/autorizacion/bulk": {
            replaceTo: "/nueva-banca-digital/pagos/autorizacion/single"
        }
    }

    constructor(
        private renderer: Renderer2,
        private router: Router,
        private menuService: MenuService,
        private userUtilsService: UserUtilsService,
        private cdr: ChangeDetectorRef,
        private translate: TranslateService,
        private contractInformation: ContractService,
        private UtilseService: UtilsService,
        private redirectService: RedirectService,
        private monexUltra2Service: MonexUltra2Service,
        private checkStatusService: ValidateTokenService,
        private systemAuthService: SystemAuthenticationService,
        private jwtService: JwtService,
        private toastService: ToastService,
    ) {
        this.redirectService.callRedirectService().subscribe({
            next: response => {
                sessionStorage.setItem("IS_REDIRECT", response?.redirect);
                pubsub.publish('renderingMenu')
            }, error: error => {
            }, complete: async () => {

            }
        })
        this.contractSelected = userUtilsService.getContractUserSelected();
        this.menuItems = this.menuService.getContractMenu();
        this.userInfoSessionStorage = userUtilsService.getUserContractInfoSessionStorage();
    }

    async ngOnInit() {
        await this.getTranslations()
        await this.renderingItems(this.menuItems);
        const desktopMedium = window.matchMedia('(min-width:992px) and (max-width: 1000px)');
        desktopMedium.addEventListener('change', () => {
            this.iconSidebar;
        });
        this.subscribeToPubsubEvent();
        this.highlightActiveMenuItem();
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            this.highlightActiveMenuItem();
        });

    }

    highlightActiveMenuItem() {
        let currentUrl = this.router.url;
        if (this.menuSpecialCases[currentUrl]) {
            currentUrl = this.menuSpecialCases[currentUrl].replaceTo;
        }
        this.updateActiveState(this.items, currentUrl);
    }
    private updateActiveState(items: any, currentUrl: string) {
        items.forEach(item => {
            item.styleClass = item.styleClass?.replace('active-parent', '').replace('active-menu-item', '').replace('no-active-menu-item','').trim();
            if (item.routerLink === currentUrl) {
                item.styleClass = (item.styleClass || '') + ' active-menu-item';
                this.highlightParents(this.items, item);
            }else if (item.routerLink === `${BASELINK}/destinatarios` && [`${BASELINK}/destinatarios/autorizacion/single`, `${BASELINK}/destinatarios/autorizacion/bulk`].includes(currentUrl)) {
                item.styleClass = ' no-active-menu-item'
            }else if (item.items) {
                this.updateActiveState(item.items, currentUrl);
            }
        });
    }

    private highlightParents(items: MenuItem[], activeItem: MenuItem) {
        items.forEach(item => {
            if (item.items && item.items.includes(activeItem)) {
                item.styleClass = (item.styleClass || '') + ' active-parent';
                this.highlightParents(this.items, item);
            }
        });
    }

    subscribeToPubsubEvent() {
        pubsub.subscribe("renderingMenu", async (msg: any, data: any) => {
            this.reBuildLateralMenu()
        })
        pubsub.subscribe("OPEN_MONEX_ULTRA", async (msg: any, data: any) => {
            await this.openMonexUltra()
        })
        pubsub.subscribe("contract", async (msg: any, data: UserInfo) => {
            this.contractSelected = data?.idContrato
            this.userInfoSessionStorage = data
            if (document.body.classList.contains('sidebar-folded')) {
                this.sidebarToggler.nativeElement.classList.toggle('active');
                this.sidebarToggler.nativeElement.classList.toggle('not-active');
                document.body.classList.remove('sidebar-folded')
                document.body.classList.add('sidebar-open')
            }
            //falta verificar si ya el usuario tiene la opcion de TyC ya ceptada, si es asi, solo redireccionamos a ultra si no mostramos dialogo
            await this.checkTCValidations(data.idContrato, data.refNumContrato)
            await this.reBuildLateralMenu();

        })
        pubsub.subscribe("changeLanguage", async (msg: any, data: any) => {
            this.translate.use(data)
            await this.getTranslations()
            this.reBuildLateralMenu()
        })
        pubsub.subscribe("getMenuOptions", async (msg: any, data: any) => {
            this.reBuildLateralMenu()
        })
        pubsub.subscribe("OPEN_VALIDATION_TOKEN_TO_MONEX_ULTRA", async (msg: any, data: any) => {
            this.systemAuthService.openValidationToken("MONEX_ULTRA_VALIDATE_TOKEN")
        })
        pubsub.subscribe("MONEX_ULTRA_VALIDATE_TOKEN", async (msg: any, data: any) => {
            let tokenStatus;
            try {
                tokenStatus = await this.checkStatusService.checkTokenStatus();
            } catch (error) {
                console.log(error)
                data.modalRef.close();
                return
            }
            if (tokenStatus) {
                data.modalRef.close();
                this.otpCode = data?.token;
                this.tokenStatus = false;
                await this.openMonexUltra();
            }
        })
    }

    private reBuildLateralMenu() {
        this.buildMenu(this.contractSelected).then(async () => {
            await this.renderingItems(this.menuService.getContractMenu());
            this.highlightActiveMenuItem();
        })
    }

    private async openMonexUltra() {
        const contractRefNum = this.userInfoSessionStorage.refNumContrato
        await this.validateUserAlreadyAcceptTC(contractRefNum)
        if (this.userAlreadyAcceptTC.code === -1) {
            this.monexUltra2Service.openModal(contractRefNum, this.translation.MONEX_ULTRA)
            return
        }
        this.openMonexUltraUrl(this.userAlreadyAcceptTC.guid)
    }


    async ngAfterViewInit() {
        this._activateMenuDropdown();
    }

    async getTranslations() {
        this.translation = await firstValueFrom(this.translate.get([
            "MONEX_ULTRA"
        ]))
    }

    async checkTCValidations(contractId: string, referenceNumber: string) {
        let showMonexUltra = await this.validateUserContractPermission(contractId);
        this.menuService.setShowMonexUltraOption(showMonexUltra)
    }

    async buildMenu(contractId: any) {
        try {
            const res = await firstValueFrom(this.menuService.getMenu(contractId))
        } catch (error) {
            console.log(error)
            return
        }
    }

    async renderingItems(menuItems?: any) {
        menuItems = menuItems || this.menuItems;
        menuItems = await this.buildMenuLabels(menuItems);
        menuItems = await this.buildSubmenuLabels(menuItems);
        this.items = [...menuItems];
        //console.log(this.items)
    }

    async buildMenuLabels(menuItems) {
        for (let menuItem of menuItems) {
            menuItem.label = await firstValueFrom(this.translate.get(menuItem.label));
        }
        return menuItems;
    }

    async buildSubmenuLabels(menuItems) {
        if (!Array.isArray(menuItems)) {
            console.error('menuItems no es un array válido:', menuItems);
            return [];
        }
        for (const item of menuItems) {
            if (item.items && Array.isArray(item.items)) {
                await Promise.all(item.items.map(async (subItem) => {
                    if (subItem.label) {
                        try {
                            subItem.label = await firstValueFrom(this.translate.get(subItem.label));
                        } catch (error) {
                            console.error('Error al traducir subItem.label:', error);
                        }
                    }
                }));
                item.items = item.items.filter((x) => {
                    if (!x.requirePermission) return true;
                    return (
                        this.UtilseService.getUserInfoSessionStorage().perJuridicaTitular === "PM" &&
                        this.contractInformation.checkPermissionNumberInContract(1071, this.contractSelected)
                    );
                });
            }
        }
        return menuItems;
    }


    baseRouteClearSubMenu() {
        command(0)
    }

    /**
     * Toggle sidebar on hamburger button click
     */
    toggleEvent!: Event

    toggleSidebar(e: Event) {
        if (this.sidebarToggler.nativeElement.classList.contains("not-active")) {
            this.closeAllPanels()
            this.closeAllSubMenus();
            //this.items = []
        } else if (this.sidebarToggler.nativeElement.classList.contains("active")) {
            this.renderingItems(this.menuService.getContractMenu())
        } else {
            this.closeAllSubMenus()
        }
        this.sidebarToggler.nativeElement.classList.toggle('active');
        this.sidebarToggler.nativeElement.classList.toggle('not-active');

        if (window.matchMedia('(min-width: 992px)').matches) {
            this.closeAllPanels()
            this.closeAllSubMenus()
            e.preventDefault();
            document.body.classList.toggle('sidebar-folded');
            this.isMenuOpened = false;
            this.isClicked = false;

        } else if (window.matchMedia('(max-width: 991px)').matches) {
            e.preventDefault();
            document.body.classList.toggle('sidebar-open');
            this.isMenuOpened = true;
        }
        this.closeAllPanels()
        this.closeAllSubMenus()
    }


    openMonexUltraUrl(guid: string) {
        const url = "https://monex.fx.com/client/#!/login?lang=es&guid=" + guid
        window.open(url, '_blank')
    }

    async validateUserContractPermission(contractId: string): Promise<boolean> {
        let resp: ValidationUserResponse
        try {
            resp = await firstValueFrom(this.monexUltra2Service.validateUserContractPermission(contractId))
        } catch (error) {
            console.log(error)
            return false;
        }
        return resp.ultra2;
    }

    async validateUserAlreadyAcceptTC(contractReferenceNumber: string): Promise<any> {
        let jwt = this.buildRequest(contractReferenceNumber);
        try {
            this.userAlreadyAcceptTC = await firstValueFrom(this.monexUltra2Service.validateUserAlreadyAcceptTC(jwt));
        } catch (error: any) {
            if (error?.error?.errorCode === 'USR31') {
                this.toastService.showToast(this.translation.MONEX_ULTRA.ERROR_SERVICE)
            } else {
                this.toastService.showToast("Ocurrio un error al obtener la informacion, Intente de nuevo mas tarde")
            }
            throw error;
        }
    }


    iconSidebar(mq: MediaQueryList) {
        if (mq.matches) {
            document.body.classList.add('sidebar-folded');
        } else {
            document.body.classList.remove('sidebar-folded');
        }
    }


    _activateMenuDropdown() {
        this.resetMenuItems();
        this.activateMenuItems();
    }

    resetMenuItems() {
        const links = document.getElementsByClassName('nav-link-ref');

        for (let i = 0; i < links.length; i++) {
            const menuItemEl = links[i];
            menuItemEl.classList.remove('mm-active');
            const parentEl = menuItemEl.parentElement;

            if (parentEl) {
                parentEl.classList.remove('mm-active');
                const parent2El = parentEl.parentElement;

                if (parent2El) {
                    parent2El.classList.remove('mm-show');
                }

                const parent3El = parent2El?.parentElement;
                if (parent3El) {
                    parent3El.classList.remove('mm-active');

                    if (parent3El.classList.contains('side-nav-item')) {
                        const firstAnchor = parent3El.querySelector('.side-nav-link-a-ref');

                        if (firstAnchor) {
                            firstAnchor.classList.remove('mm-active');
                        }
                    }

                    const parent4El = parent3El.parentElement;
                    if (parent4El) {
                        parent4El.classList.remove('mm-show');

                        const parent5El = parent4El.parentElement;
                        if (parent5El) {
                            parent5El.classList.remove('mm-active');
                        }
                    }
                }
            }
        }
    };


    activateMenuItems() {

        const links: any = document.getElementsByClassName('nav-link-ref');
        let menuItemEl: any = null;

        for (let i = 0; i < links.length; i++) {
            // tslint:disable-next-line: no-string-literal
            if (window.location.pathname === links[i]['pathname']) {
                menuItemEl = links[i];

                break;
            }
        }

        if (menuItemEl) {
            menuItemEl.classList.add('mm-active');
            const parentEl = menuItemEl.parentElement;

            if (parentEl) {
                parentEl.classList.add('mm-active');

                const parent2El = parentEl.parentElement;
                if (parent2El) {
                    parent2El.classList.add('mm-show');
                }

                const parent3El = parent2El.parentElement;
                if (parent3El) {
                    parent3El.classList.add('mm-active');

                    if (parent3El.classList.contains('side-nav-item')) {
                        const firstAnchor = parent3El.querySelector('.side-nav-link-a-ref');

                        if (firstAnchor) {
                            firstAnchor.classList.add('mm-active');
                        }
                    }

                    const parent4El = parent3El.parentElement;
                    if (parent4El) {
                        parent4El.classList.add('mm-show');

                        const parent5El = parent4El.parentElement;
                        if (parent5El) {
                            parent5El.classList.add('mm-active');
                        }
                    }
                }
            }
        }
    };

    buildOperation(refNumContrato: any) {
        return {
            refNumContrato: refNumContrato
        };
    }

    buildRequest(refNumContrato: any) {
        let operation = this.buildOperation(refNumContrato)
        return this.generateRequestJwt({
            ...operation,
            otpCode: this.otpCode
        })
    }

    generateRequestJwt(payload: any) {
        const {otpCode, ...rest} = payload
        return this.jwtService.signRequest("operacion", rest, otpCode)
    }

    ngOnDestroy(): void {
        pubsub.clearAllSubscriptions()
    }


    onMouseEnter() {
        this.isMouseInsideMenu = true
        if (!this.isMenuOpened && this.sidebarToggler.nativeElement.classList.contains('active')) {
            this.enterTimeout = setTimeout(() => {
                if (this.isMouseInsideMenu) {
                    this.openAllPanels()

                    this.sidebarToggler.nativeElement.classList.remove('active')
                    this.sidebarToggler.nativeElement.classList.add('not-active')

                    document.body.classList.remove('sidebar-folded');
                    document.body.classList.add('sidebar-open');
                }
            }, 280)
        }
    }

    onMouseLeave() {
        this.isMouseInsideMenu = false;
        if (!this.isClicked) {
            if (!this.isMenuOpened && this.sidebarToggler.nativeElement.classList.contains('not-active')) {
                clearTimeout(this.enterTimeout)
                this.sidebarToggler.nativeElement.classList.add('active')
                this.sidebarToggler.nativeElement.classList.remove('not-active')

                document.body.classList.remove('sidebar-open');
                document.body.classList.add('sidebar-folded');

                if (document.body.classList.contains('sidebar-folded')) {
                    this.closeAllPanels()
                    this.isMenuOpened = false;
                }
            }
            if (document.body.classList.contains('sidebar-folded'))
                this.closeAllPanels()
        }
    }


    closeAllSubMenus() {
        if (this.items) {
            this.items.forEach(item => {
                if (item.expanded) {
                    item.expanded = false;
                }

                if (item.items) {
                    item.items.forEach(subItem => {
                        subItem.expanded = false;
                    });
                }
            });
        }

    }

    closeAllPanels() {
        if (this.items) {
            this.items = this.items.map(item => ({
                ...item,
                expanded: item.expanded !== undefined ? false : item.expanded
            }))
        }
    }

    openAllPanels() {
        if (this.items) {
            this.items = this.items.map(item => ({
                ...item,
                expanded: item.expanded !== undefined ? true : item.expanded
            }))
        }
    }

    onClick($event: MouseEvent) {
        this.isClicked = true;
        if (document.body.classList.contains('sidebar-folded')) {
            this.isClicked = false;
        }
        //console.log(this.isClicked)
    }

}
